<template>
  <h3 class="text-2xl md:text-3xl xl:text-4xl font-serif break-long-string line-clamp-2" :class="count ? 'flex items-center gap-2' : ''">
    <slot />
    <span v-if="count" class="text-gray-400 text-lg font-semibold font-sans mt-1.5">({{count}})</span>
  </h3>
</template>

<script setup>
  defineProps({
    count: [Number, String],
  });
</script>
